import { render, staticRenderFns } from "./ActF2bBotao.vue?vue&type=template&id=3d14c229&scoped=true&"
import script from "./ActF2bBotao.vue?vue&type=script&lang=js&"
export * from "./ActF2bBotao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d14c229",
  null
  
)

export default component.exports